import { render } from "./Card.vue?vue&type=template&id=6d783835"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=6d783835&lang=css"
script.render = render

export default script